// extracted by mini-css-extract-plugin
module.exports = {"groupHint":"styles_groupHint__1HZbO","group":"styles_group__kp9e3"};